export default __webpack_public_path__ + "static/media/hero-level-1-chars-desk.b4806b0a.webp";